









import Base from './Base.vue';
import { RozsahDate } from '../constants';

export default Base.extend({
	name: 'ZakazkaVymaz',
	components: {
		BaseFilterSestav: Base,
	},
	created() {
		this.RozsahDate = RozsahDate.casDnes;
	},
});
